import { Layout } from "@visma-netvisor/react-component-library";
import { useState } from "react";
import CompanyAlreadyExist from "./CompanyAlreadyExist";
import CompanyCreationAuthExpired from "./CompanyCreationAuthExpired";
import CompanyCreationFailed from "./CompanyCreationFailed";
import CompanyCreationInProgress from "./CompanyCreationInProgress";
import CompanyCreationSuccess from "./CompanyCreationSuccess";
import ProgressContent from "./ProgressContent";
import { ServiceNeedProvider } from "../../context/ServiceNeedContext";

type CreationStatusContentProps = {
  orderId: string;
  tradeRegistrationYear: number | undefined;
  activationError: boolean;
  authExpired: boolean;
  organizationIdentifier: string | undefined;
  companyAlreadyExist: boolean;
  companyCreatedSuccess: boolean;
  setCompanyAlreadyExist: (companyExists: boolean) => void;
  setActivationError: (activationError: boolean) => void;
  setCompanyCreatedSuccess: (companyCreated: boolean) => void;
};

const CreationStatusContent = ({
  orderId,
  tradeRegistrationYear,
  activationError,
  authExpired,
  organizationIdentifier,
  companyAlreadyExist,
  companyCreatedSuccess,
  setCompanyAlreadyExist,
  setActivationError,
  setCompanyCreatedSuccess,
}: CreationStatusContentProps) => {
  const [progressText, setProgressText] = useState("");

  const progressContentProps = {
    orderId,
    activationError,
    setCompanyAlreadyExist,
    setActivationError,
    setProgressText,
    setCompanyCreatedSuccess,
  };

  const renderCompanyCreation = () => {
    if (companyCreatedSuccess) {
      return (
        <ServiceNeedProvider tradeRegistrationYear={tradeRegistrationYear}>
          <CompanyCreationSuccess />
        </ServiceNeedProvider>
      );
    }
    if (companyAlreadyExist) {
      return <CompanyAlreadyExist />;
    }
    if (authExpired) {
      return (
        <CompanyCreationAuthExpired
          organizationIdentifier={organizationIdentifier}
        />
      );
    }
    return (
      <>
        <ProgressContent {...progressContentProps} />
        {activationError ? (
          <CompanyCreationFailed />
        ) : (
          <CompanyCreationInProgress progressText={progressText} />
        )}
      </>
    );
  };

  return (
    <Layout.Flex flexDirection="column" flexGap={0}>
      {renderCompanyCreation()}
    </Layout.Flex>
  );
};

export default CreationStatusContent;
